import { useDispatch } from "react-redux";
import { startFetch } from "../../services/fetch/startFetch";
import { TotemBasicService } from "../../services/TotemBasicService";
import {
    getSolicitudesTotemBasic,
    deleteSolicitudTotemBasic,
    getBoxesTotemBasic,
    insertBoxTotemBasic,
    updateBoxTotemBasic,
    deleteBoxTotemBasic,
    getBoxesTomadosTotemBasic,
    getOpcionesTotemBasic,
    insertOpcionTotemBasic,
    updateOpcionTotemBasic,
    deleteOpcionTotemBasic,
    getSubOpcionesTotemBasic,
    insertSubOpcionTotemBasic,
    updateSubOpcionTotemBasic,
    deleteSubOpcionTotemBasic,
    insertOpcionPorBoxTotemBasic,
    tomarSolicitudTotemBasic,
    liberarSolicitudTotemBasic,
} from "../../reducers/totemBasic/totemBasicActions";
import { startAlerta } from "../../actions/ui/alertas";

export const useTotemBasic = () => {
    const dispatch = useDispatch();
    return {
        get: {
            solicitudes: async () => {
                dispatch(
                    startFetch(
                        () => TotemBasicService.getSolicitudes(),
                        (data) => {
                            dispatch(getSolicitudesTotemBasic(data));
                        },
                        false
                    )
                );
            },
            boxes: () => {
                dispatch(
                    startFetch(
                        () => TotemBasicService.getBoxes(),
                        (data) => {
                            dispatch(getBoxesTotemBasic(data));
                        }
                    )
                );
            },
            boxesTomados: () => {
                dispatch(
                    startFetch(
                        () => TotemBasicService.getBoxesTomados(),
                        (data) => {
                            dispatch(getBoxesTomadosTotemBasic(data));
                        }
                    )
                );
            },
            opciones: () => {
                dispatch(
                    startFetch(
                        () => TotemBasicService.getOpciones(),
                        (data) => {
                            dispatch(getOpcionesTotemBasic(data));
                        }
                    )
                );
            },
            subOpciones: () => {
                dispatch(
                    startFetch(
                        () => TotemBasicService.getSubOpciones(),
                        (data) => {
                            dispatch(getSubOpcionesTotemBasic(data));
                        }
                    )
                );
            },
        },
        insert: {
            solicitud: (solicitudData, updateData) => {
                dispatch(
                    startFetch(
                        () => TotemBasicService.insertSolicitud(solicitudData),
                        (ticket) => {
                            updateData(ticket)
                        }
                    )
                );
            },
            box: (boxData, closeModal) => {
                dispatch(
                    startFetch(
                        () => TotemBasicService.insertBox(boxData),
                        (data) => {
                            dispatch(insertBoxTotemBasic(data));
                            closeModal()
                        }
                    )
                );
            },
            opcion: (opcionData, closeModal) => {
                dispatch(
                    startFetch(
                        () => TotemBasicService.insertOpcion(opcionData),
                        (data) => {
                            dispatch(insertOpcionTotemBasic(data));
                            closeModal()
                        }
                    )
                );
            },
            subOpcion: (subOpcionData, closeModal) => {
                dispatch(
                    startFetch(
                        () => TotemBasicService.insertSubOpcion(subOpcionData),
                        (data) => {
                            dispatch(insertSubOpcionTotemBasic(data));
                            closeModal()
                        }
                    )
                );
            },
            opcionPorBox: (opcionPorBoxData) => {
                dispatch(
                    startFetch(
                        () => TotemBasicService.insertOpcionPorBox(opcionPorBoxData),
                        (data) => {
                            dispatch(insertOpcionPorBoxTotemBasic(data));
                        }
                    )
                );
            },
        },
        update: {
            box: (boxData, closeModal) => {
                dispatch(
                    startFetch(
                        () => TotemBasicService.updateBox(boxData),
                        (data) => {
                            dispatch(updateBoxTotemBasic(data));
                            closeModal()
                        }
                    )
                );
            },
            opcion: (opcionData, closeModal) => {
                dispatch(
                    startFetch(
                        () => TotemBasicService.updateOpcion(opcionData),
                        (data) => {
                            dispatch(updateOpcionTotemBasic(data));
                            closeModal()
                        }
                    )
                );
            },
            subOpcion: (subOpcionData, closeModal) => {
                dispatch(
                    startFetch(
                        () => TotemBasicService.updateSubOpcion(subOpcionData),
                        (data) => {
                            dispatch(updateSubOpcionTotemBasic(data));
                            closeModal()
                        }
                    )
                );
            },
            tomarBox: (data, getBoxes) => {
                dispatch(
                    startFetch(
                        () => TotemBasicService.tomarBox(data),
                        (boxTomado) => {
                            // dispatch(tomarBoxTotemBasic(boxTomado));
                            getBoxes()
                            dispatch(startAlerta("Box Tomado Exitosamente", "success", "Comando Exitoso"))
                        }
                    )
                );
            },
            liberarBox: (data, getBoxes) => {
                dispatch(
                    startFetch(
                        () => TotemBasicService.liberarBox(data),
                        () => {
                            // dispatch(liberarBoxTotemBasic(data));
                            getBoxes()
                            dispatch(startAlerta("Box Liberado Exitosamente", "success", "Comando Exitoso"))
                        }
                    )
                );
            },
            tomarSolicitud: (data) => {
                dispatch(
                    startFetch(
                        () => TotemBasicService.tomarSolicitud(data),
                        (solicitud) => {
                            dispatch(tomarSolicitudTotemBasic(solicitud))
                            dispatch(startAlerta("Solicitud Confirmada Exitosamente", "success", "Comando Exitoso"))
                        }
                    )
                );
            },
            liberarSolicitud: (data) => {
                dispatch(
                    startFetch(
                        () => TotemBasicService.liberarSolicitud(data),
                        (solicitud) => {
                            dispatch(liberarSolicitudTotemBasic(solicitud))
                            dispatch(startAlerta("Solicitud Liberada Exitosamente", "success", "Comando Exitoso"))
                        }
                    )
                );
            },
        },
        remove: {
            solicitud: (solicitudData) => {
                dispatch(
                    startFetch(
                        () => TotemBasicService.deleteSolicitud(solicitudData),
                        () => {
                            dispatch(deleteSolicitudTotemBasic(solicitudData));
                        }
                    )
                );
            },
            box: (boxData) => {
                dispatch(
                    startFetch(
                        () => TotemBasicService.deleteBox(boxData),
                        () => {
                            dispatch(deleteBoxTotemBasic(boxData));
                        }
                    )
                );
            },
            opcion: (opcionData) => {
                dispatch(
                    startFetch(
                        () => TotemBasicService.deleteOpcion(opcionData),
                        () => {
                            dispatch(deleteOpcionTotemBasic(opcionData));
                        }
                    )
                );
            },
            subOpcion: (subOpcionData) => {
                dispatch(
                    startFetch(
                        () => TotemBasicService.deleteSubOpcion(subOpcionData),
                        () => {
                            dispatch(deleteSubOpcionTotemBasic(subOpcionData));
                        }
                    )
                );
            },
        }
    };
};
